import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Fire Prevention Week' },
	{
		name: 'description',
		content: 'Fire Prevention Week is the week of October 9.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">Fire Prevention Week</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The week of October 9 is Fire Prevention week. Here are a few tips to
				remember:
			</p>
			<h2 className="p-4 text-2xl font-semibold">Cooking</h2>
			<ul>
				<li>Keep flammables a safe distance from the stove and oven.</li>
				<li>Don't wear loose clothing when you are cooking.</li>
				<li>Don't leave the kitchen unattended when food is cooking.</li>
			</ul>
			<h2 className="p-4 text-2xl font-semibold">Heating</h2>
			<ul>
				<li>
					When using a wood stove, see our{' '}
					<Link
						to="/articles/wood-stove-safety/"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						wood stove safety
					</Link>{' '}
					article.
				</li>
				<li>Have your furnace inspected by a heating professional.</li>
				<li>Replace furnace filters as needed.</li>
				<li>Clean the duct system and/or chimney regularly.</li>
			</ul>
			<h2 className="p-4 text-2xl font-semibold">Matches</h2>
			<ul>
				<li>
					Teach your children the importance of being careful with lighters and
					matches. Do not leave them within reach of children.
				</li>
				<li>When you use a match, be sure it is cool before discarding.</li>
			</ul>
			<h2 className="p-4 text-2xl font-semibold">Electric</h2>
			<ul>
				<li>
					Don't overload your electrical circuits with excessive power strips or
					by drawing too much power from a single outlet.
				</li>
				<li>
					Be careful with extension cords - they can cause fires if not used
					properly.
				</li>
				<li>
					Have the electrical system inspected by an electrician as needed. If
					you suspect that something is not right, consult a professional.
				</li>
			</ul>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				With all you do to prevent a fire, you may still be faced with a fire
				some day. For this reason, we recommend that all homes have smoke
				detectors (don't forget to check the batteries) and fire extinguishers
				(replace as necessary). Check to make sure all windows open freely, and
				review the fire escape plan. Be sure that everyone in your family knows
				what to do in a fire. Stay low to the floor (the air is safer there). If
				you catch on fire, stop, drop, and roll.
			</p>
		</>
	)
}
